<template>
    <inertia-head
        :title="
            title
                ? `${title} - King Sound Reinforcement`
                : 'King Sound Reinforcement'
        "
    >
        <slot />
    </inertia-head>
</template>

<script>
export default {
    name: "HeadLayout",

    props: {
        title: String,
    },
};
</script>

<style scoped></style>
